import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { Loading } from '../../../../../../common/loading'
import { Notification } from '../../../../../../common/notification'
import { mapViewBy } from '../../constant'
import { selectCompareVal, selectData, selectLoading } from '../../store/slice'
import ChartNumberOfCompanies from './ChartNumberOfCompanies'
import TableNumberOfCompanies from './TableNumberOfCompanies'

const NumberOfCompanies = ({
  viewBy,
  isDynamicReport,
  settingDynamic = {},
}) => {
  const loading = useSelector(selectLoading)
  const compareValStore = useSelector(selectCompareVal)
  const { compareBetweenRatio: compareValDyn } = settingDynamic
  const data = useSelector(selectData)
  const compareVal = isDynamicReport ? compareValDyn : compareValStore
  const defaultData = data[compareVal]?.defaultIndustry
  const compareData = data[compareVal]?.comparingIndustry
  const year = defaultData?.nocYear || compareData?.nocYear || ''

  return (
    <div>
      <Element style={{ fontSize: 14, fontWeight: 600, marginBottom: 14 }}>
        <Translate
          value="companyAnalysis.industryAnalysis.NUMBER_OF_COMPANIES"
          year={year}
        />
      </Element>
      {loading ? (
        <div className="positionRelative" style={{ height: 350 }}>
          <Loading />
        </div>
      ) : (
        <>
          {!defaultData?.noc && !compareData?.noc ? (
            <div style={{ height: 350, width: '100%' }}>
              <Notification />
            </div>
          ) : (
            <>
              {viewBy === mapViewBy.chart.value ? (
                <ChartNumberOfCompanies
                  isDynamicReport={isDynamicReport}
                  settingDynamic={settingDynamic}
                />
              ) : (
                <TableNumberOfCompanies
                  isDynamicReport={isDynamicReport}
                  settingDynamic={settingDynamic}
                  year={year}
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  )
}

export default NumberOfCompanies
